/*
 * WCS: the texts of Shopify's cookie banner, from the theme (the shop nudge, design variant B,
 * 2026-10-15). The heading becomes "Kolačići" / "Cookies", the sentence the design's short one, and
 * the policy link reads "Politika kolačića" / "Cookie policy" and opens the shop's cookie policy page
 * in place of the privacy policy that the admin setting names. The texts are theme translations that
 * `snippets/stylesheets.liquid` passes on this script's data attributes, so the change stays on the
 * theme that carries this file; the admin texts of the banner do not change. The buttons and their
 * handlers are Shopify's and are not touched. Shopify adds the banner after the page loads, so the
 * script waits for it.
 */
(() => {
  const data = document.currentScript?.dataset;
  if (!data) return;

  const apply = () => {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    if (banner.dataset.wcsTexts === 'done') return true;
    const title = document.getElementById('shopify-pc__banner__body-title');
    const link = document.getElementById('shopify-pc__banner__body-policy-link');
    if (!title || !link) return false;

    if (data.title) title.textContent = data.title;
    if (data.policy) link.textContent = data.policy;
    if (data.url) link.href = data.url;
    const paragraph = link.closest('p');
    if (paragraph && data.text) paragraph.replaceChildren(document.createTextNode(`${data.text} `), link);
    banner.dataset.wcsTexts = 'done';
    return true;
  };

  if (apply()) return;
  const observer = new MutationObserver(() => {
    if (apply()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 30000);
})();
